export default __webpack_public_path__ + "static/media/m_use_action_back4.71f1d940.png";